import { defineMessages } from 'react-intl';

export default defineMessages({
    interestedByPlaceholder: {
        id: 'InterestedBy.editDialog.interestedBy.placeholder',
        defaultMessage: 'Vue.js, Blockchain, Datadog...'
    }
});
